/**
 * Pure helpers for Sites Management table row/column building (no React hooks).
 */

export function sortAndJoinCriterias(siteCriterias) {
  if (!siteCriterias || siteCriterias.length === 0) {
    return '-'
  }
  return [...siteCriterias].sort((a, b) => {
    if (a < b) {
      return -1
    }
    if (a > b) {
      return 1
    }
    return 0
  }).join(', ')
}

export function getIbaStatusIdForRow(site) {
  return site?.IbaStatus?.id ?? site?.IbaStatusHistory?.id ?? site?.iba_status_id
}
